var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C2.91568 0 0 2.91568 0 6.5C0 10.0843 2.91568 13 6.5 13C10.0843 13 13 10.0838 13 6.5C13 2.91619 10.0843 0 6.5 0ZM6.5 11.993C3.47153 11.993 1.00697 9.52897 1.00697 6.5C1.00697 3.47103 3.47153 1.00697 6.5 1.00697C9.52847 1.00697 11.993 3.47103 11.993 6.5C11.993 9.52897 9.52897 11.993 6.5 11.993Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01748 5.95115H7.00355V3.93721C7.00355 3.65929 6.77849 3.43372 6.50005 3.43372C6.22162 3.43372 5.99656 3.65929 5.99656 3.93721V5.95115H3.98262C3.70419 5.95115 3.47913 6.17672 3.47913 6.45464C3.47913 6.73257 3.70419 6.95814 3.98262 6.95814H5.99656V8.97207C5.99656 9.25 6.22162 9.47557 6.50005 9.47557C6.77849 9.47557 7.00355 9.25 7.00355 8.97207V6.95814H9.01748C9.29592 6.95814 9.52098 6.73257 9.52098 6.45464C9.52098 6.17672 9.29592 5.95115 9.01748 5.95115Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.ea3503b2.svg";
export { ForwardRef as ReactComponent };